export const environment = {
  production: false,
  enableMonitoring: false,
  baseUrl: 'https://api.oas.dev.qodix.dev',
  cookieConsentDomain: 'localhost',
  gaId: ''
};